// extracted by mini-css-extract-plugin
module.exports = {"ROOT":"skeleton_ROOT__X__EC","item":"skeleton_item__aEZ2J","lightning":"skeleton_lightning__TjZA1","text":"skeleton_text__8oMWa","circle":"skeleton_circle__Il3Kt"};